import React, { useState, useEffect } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import { APIBaseURL } from "../Config";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import DateRange from "./main/DateRange";
import GoogleMapComponent from "./GoogleMapCntrLoc";
import GoogleMapComponent_v2 from "./GoogleMapCntrLocV2";
// import GoogleMapComponent from "./main/DateRange";

// 

export default function Jobs() {
  const [status, setStatus] = useState("0");
  const [equipmentId, setEquipmentId] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [JobType, setJobType] = useState("");
  const [ContainerNo, setContainerNo] = useState("");
  const [equipments, setEquipments] = useState([]);
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ModalData, setModalData] = useState("");
  const [jobTypeFilter, setJobTypeFilter] = useState(null); // Job Type Filter
  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/rst/jobs?status=${status}`;

    if (page) {
      url += `&page=${page}`;
    }
    if (equipmentId) {
      url += `&equipment_id=${equipmentId}`;
    }
    if (JobType) {
      url += `&job_type=${JobType}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    if (ContainerNo) {
      url += `&container_no=${ContainerNo}`;
    }

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  // const filteredJobs = Data?.data?.filter((job) => {
  //   // First filter by status
  //   if (job.status !== status) return false;

  //   // Then filter by job type if filter is set
  //   if (jobTypeFilter) {
  //     if (jobTypeFilter === "rake_in" || jobTypeFilter === "rake_out") {
  //       return job.job_type === "rake_in" || job.job_type === "rake_out";
  //     } else if (jobTypeFilter === "gate_in" || jobTypeFilter === "gate_out") {
  //       return job.job_type === "gate_in" || job.job_type === "gate_out";
  //     }
  //   }

  //   return true;
  // });

  const filteredJobs = Data?.data?.filter((job) => {
    if (job.status !== status) return false;

    if (jobTypeFilter) {
      if (jobTypeFilter === "rake_in" || jobTypeFilter === "rake_out") {
        return job.job_type === "rake_in" || job.job_type === "rake_out";
      } else if (jobTypeFilter === "gate_in" || jobTypeFilter === "gate_out") {
        return job.job_type === "gate_in" || job.job_type === "gate_out";
      }
    }

    return true;
  });


  useEffect(() => {
    if (status) {
      GetData();
    }
  }, [status, equipmentId, start, end, JobType, ContainerNo]);

  const GetEquipment = async () => {
    setLoading(true);
    let url = `${APIBaseURL}/get/equipments`;

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setEquipments(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetEquipment();
  }, []);

  const GetModalData = async (data) => {
    // setLoading(true);
    setModalData(data);
  };

  const handleDataFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setEquipmentId(formData.get("equipment_id") || "");
    setJobType(formData.get("job_type") || "");
    setContainerNo(formData.get("container_no") || "");
    let range = formData.get("range");
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
    // GetData();
    // container_no
  };

  const [showIndex, setShowIndex] = useState(null);

  const toggleDropdown = (index) => {
    setShowIndex(showIndex === index ? null : index);
  };
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                {/* <div className="mb-6">
                  <ul className="nav nav-pills">
                    <li className="nav-item pe-3">
                      <button
                        className={`${
                          status === "0"
                            ? "btn btn-primary"
                            : "btn btn-label-primary"
                        }`}
                        onClick={() => setStatus("0")}
                      >
                        Job in queue
                      </button>
                    </li>
                    <li className="nav-item pe-3">
                      <button
                        className={`${
                          status === "1"
                            ? "btn btn-primary"
                            : "btn btn-label-primary"
                        }`}
                        onClick={() => setStatus("1")}
                      >
                        Active
                      </button>
                    </li>
                    <li className="nav-item  pe-3">
                      <button
                        className={`${
                          status === "2"
                            ? "btn btn-primary"
                            : "btn btn-label-primary"
                        }`}
                        onClick={() => setStatus("2")}
                      >
                        Completed
                      </button>
                    </li>
                  </ul>
                </div> */}

                <div className="mb-6">
                  <ul className="nav nav-pills">
                    {/* Job in Queue */}
                    <li className="nav-item pe-3">
                      <button
                        className={`${status === "0" ? "btn btn-primary" : "btn btn-label-primary"}`}
                        onClick={() => {
                          setStatus("0");
                          setJobTypeFilter(null);
                        }}
                      >
                        Job in queue
                      </button>
                    </li>

                    {/* Active */}
                    <li className="nav-item pe-3">
                      <button
                        className={`${status === "1" ? "btn btn-primary" : "btn btn-label-primary"}`}
                        onClick={() => {
                          setStatus("1");
                          setJobTypeFilter(null);
                        }}
                      >
                        Active
                      </button>
                    </li>

                    {/* Completed */}
                    <li className="nav-item pe-3">
                      <button
                        className={`${status === "2" ? "btn btn-primary" : "btn btn-label-primary"}`}
                        onClick={() => {
                          setStatus("2");
                          setJobTypeFilter(null);
                        }}
                      >
                        Completed
                      </button>
                    </li>
                  </ul>

                  {/* Sub-buttons for Job in Queue and Completed */}
                  {(status === "0" || status === "2") && (
                    <div className="mt-2 d-flex">
                      <div className="btn-group" role="group">
                        <button
                          type="button"
                          className={`btn ${(jobTypeFilter === "rake_in" || jobTypeFilter === "rake_out") ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setJobTypeFilter(prev =>
                            (prev === "rake_in" || prev === "rake_out") ? null : "rake_in"
                          )}
                        >
                          Rake
                        </button>
                        <button
                          type="button"
                          className={`btn ${(jobTypeFilter === "gate_in" || jobTypeFilter === "gate_out") ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setJobTypeFilter(prev =>
                            (prev === "gate_in" || prev === "gate_out") ? null : "gate_in"
                          )}
                        >
                          Gate
                        </button>
                      </div>
                      {jobTypeFilter && (
                        <button
                          className="btn btn-label-secondary ms-2"
                          onClick={() => setJobTypeFilter(null)}
                        >
                          Clear Filter
                        </button>
                      )}
                    </div>
                  )}
                </div>


                <div className="row">
                  <div className="card mb-4">
                    <div className="card-body">
                      <form action="" onSubmit={handleDataFilter}>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              {/* <label for="job_type">Job Type</label> */}
                            </div>
                            <div className="form-floating form-floating-outline">
                              <select
                                name="job_type"
                                id="job_type"
                                className="form-select"
                              // onChange={(e) =>
                              //   setEquipmentId(e.target.value)
                              // }
                              >
                                <option value="">Select Job Type</option>
                                <option value="gate_in">Gate In</option>
                                <option value="rake_in">Rake In</option>
                                <option value="gate_out">Gate Out</option>
                                <option value="rake_out">Rake Out</option>
                              </select>
                              <label for="job_type">Job Type</label>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              {/* <label for="job_type">Job Type</label> */}
                            </div>
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Container Number"
                                name="container_no"
                              />
                              <label for="job_type">Container No</label>
                            </div>
                          </div>
                          {status === "2" && (
                            <>
                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                  {/* <label for="equipment_id">Equipment Name</label> */}
                                </div>
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="equipment_id"
                                    id="equipment_id"
                                    className="form-select"
                                  // onChange={(e) =>
                                  //   setEquipmentId(e.target.value)
                                  // }
                                  >
                                    <option value="">Select Equipment</option>
                                    {equipments?.map((equipment, i) => (
                                      <option value={equipment.name} key={i}>
                                        {equipment.equipment_name}
                                      </option>
                                    ))}
                                  </select>
                                  <label for="equipment_id">
                                    Equipment Name
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <DateRange />
                              </div>
                            </>
                          )}
                          <div className="col-md-3">
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={() => window.location.reload()}
                            >
                              <i className="ri-restart-line ri-20px" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">

                        <table className="table table-striped table-font">
                          <thead>
                            <tr className="table-primary text-center">
                              <th>S.No</th>
                              <th>Job Type</th>
                              {(status === "1" || jobTypeFilter === "rake_in" || jobTypeFilter === "rake_out") && <th>Train No</th>}
                              <th>Container No.</th>
                              <th>Container Size</th>
                              <th>Source</th>
                              {/* <th>Interim location</th> */}
                              {status === "2" && <th>Assigned</th>}
                              {status === "2" ? <th>Placed</th> : <th>Destination</th>}
                              {(status === "2" || status === "1") && <th>Equipment</th>}
                              {/* { status === "0" && <th>Assigned CHE</th>} */}
                              {status === "0" ? (
                                <th>Job Assign Time</th>
                              ) : status === "1" ? (
                                <th>Job Assign Time</th>
                              ) : (
                                
                                <th>Stack Placement Time</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {filteredJobs?.map((data, i) => (
                              <tr key={i} 
                              >
                                {status != '2' ? (
                                  <td 
                                  data-bs-toggle="modal"
                                  data-bs-target="#ModalView"
                                  className=""
                                  onClick={() =>
                                    setModalData(data)
                                  }>{i + 1}</td>
                                ) : (
                                  <td>{i + 1}</td>
                                )}

                                <td>{data.job_type.toUpperCase()}</td>
                                {(status === "1" || jobTypeFilter === "rake_in" || jobTypeFilter === "rake_out") && (
                                  <td>{data.rake_data?.train_no ?? 'RAKEID_'+data.rake_out_data?.rake_id  ?? 'N/A'}</td>
                                )}
                                <td>{data.container_no}</td>
                                <td>{data?.container_master?.container_size ?? data?.container_size ?? ""}</td>
                                
                                <td>
                                {
                                  ((data.pickup_from ?? data?.container_master?.stack_name ?? 'PATH').endsWith('*') 
                                    ? (data.pickup_from ?? data?.container_master?.stack_name ?? 'PATH').slice(0, -1) 
                                    : (data.pickup_from ?? data?.container_master?.stack_name ?? 'PATH'))
                                }
                              </td>
                                {/* <td>{data.mid_loc ?? 'N/A'}</td> */}
                                <td>{data.drop_to ?? 'N/A'} {data.drop_height ?? ''}</td>
                                {status === "1" && <td>{data.equipment_id}</td>}
                                {status === "2" && (
                                  <>
                                    <td>{data?.yard_tran?.unlocklocation}</td>
                                    <td>{data.equipment_id ?? data?.yard_tran?.equipmentid}</td>
                                  </>
                                )}
                                {/* {status === "0" && <td>{data.view_equipment_id}</td>} */}
                                {/* <td>{formatToDateTime(data.created_at)}</td> */}
                                {status === "0" ? (
                                <td>{formatToDateTime(data.created_at)}</td>
                              ) : status === "2" ? (
                                <td>{formatToDateTime(data?.yard_tran?.unlockdatetime)}</td>
                              ) : (
                                <td>{formatToDateTime(data.created_at)}</td>
                              )}
                              </tr>
                            ))}
                             
                           
                          </tbody>        
                        </table>

                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data.links.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                              ? "Previous"
                                              : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${link.active === true
                                              ? "active"
                                              : ""
                                              }  ${showData == "Next" &&
                                                Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                  ? "disabled"
                                                  : ""
                                              } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                    Data.current_page - 1
                                                  )
                                                  : showData == "Next"
                                                    ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                    : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="ModalView"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Job Details
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setModalData("")}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          {/* <h4>Job ID :  {ModalData.id} </h4> */}
                          <p>Assigned CHE Names : <b> {ModalData.view_equipment_id}</b></p>
                          <p>Container No : <b> {ModalData.container_no}</b></p>
                          <p>PickUp Loc : <b> {ModalData.pickup_from}</b></p>
                          <p>Drop Loc : <b> {ModalData.drop_to} {ModalData.drop_height}</b></p>
                          
                          <hr />
                          <p>Drop Point Lat Longs : </p>
                          {ModalData.drop_lat_long?.split(',')[0] || 'N/A'}
                          <hr />
                          <GoogleMapComponent_v2 lat_long={ModalData.drop_lat_long?.split(',')[0] || null}/>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={() => setModalData("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}

